import SidePanel from "PFComponents/side_panel/side_panel";
import { useTemplates } from "PFCore/hooks/queries/analytics/reports/use_templates";
import React from "react";
import { useTranslation } from "react-i18next";

import { Template } from "../../types/reports";
import { Templates } from "../templates";

const REFETCH_INTERVAL_MS = 2 * 60 * 1000;

type TemplatesSidePanelProps = {
  show: boolean;
  onClose: () => void;
};

export const TemplatesSidePanel = ({ show, onClose }: TemplatesSidePanelProps) => {
  const { t } = useTranslation("insights");
  const { data: templatesData, isLoading: templatesIsLoading } = useTemplates({
    enabled: true,
    refetchInterval: REFETCH_INTERVAL_MS
  });

  return (
    <SidePanel title={t("actionButtons.manageTemplates")} show={show} onClose={onClose} size="large">
      <Templates
        isLoading={templatesIsLoading}
        templates={(templatesData?.entries as Template[]) ?? []}
        onClose={onClose}
      />
    </SidePanel>
  );
};
